import React from 'react';

interface OcmcsIconProps {
  color?: string;
  height?: number | string;
  width?: number | string;
  opacity?: number;
  style?: React.CSSProperties;
  className?: string;
  'aria-label'?: string;
}

const OcmcsIcon: React.FC<OcmcsIconProps> = ({
  color = '#2372b9',
  height = 14,
  width = 14,
  opacity = 1,
  style,
  className,
  'aria-label': ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={height}
    width={width}
    viewBox="0 0 640 640"
    style={{ opacity, ...style }}
    className={className}
    aria-label={ariaLabel}
    role={ariaLabel ? 'img' : 'presentation'}
  >
    {/* Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com
        License - https://fontawesome.com/license/free
        Copyright 2026 Fonticons, Inc. */}
    <path
      fill={color}
      d="M288 96L211.7 96C182.3 96 156.6 116.1 149.6 144.6L65.4 484.5C57.9 514.7 80.8 544
         112 544L321.4 544C310.2 519.6 304 492.6 304 464C304 435.4 310.2 408.3 321.4 384C320.9
         384 320.4 384 319.9 384C302.2 384 287.9 369.7 287.9 352L287.9 288C287.9 270.3 302.2 256
         319.9 256C337.6 256 351.9 270.3 351.9 288L351.9 337C387.1 297.1 438.6 272 495.9 272C504.9
         272 513.7 272.6 522.4 273.8L490.4 144.6C483.4 116.1 457.8 96 428.3 96L351.9 96L351.9 160C351.9
         177.7 337.6 192 319.9 192C302.2 192 287.9 177.7 287.9 160L287.9 96zM640 464C640 384.5 575.5
         320 496 320C416.5 320 352 384.5 352 464C352 543.5 416.5 608 496 608C575.5 608 640 543.5 640
         464zM553.4 403.1C560.5 408.3 562.1 418.3 556.9 425.4L492.9 513.4C490.1 517.2 485.9 519.6
         481.2 519.9C476.5 520.2 471.9 518.6 468.6 515.3L428.6 475.3C422.4 469.1 422.4 458.9 428.6
         452.7C434.8 446.5 445 446.5 451.2 452.7L478 479.5L531 406.6C536.2 399.5 546.2 397.9
         553.4 403.1z"
    />
  </svg>
);

export default OcmcsIcon;
